/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PatientCommonExpression } from './PatientCommonExpression';
import {
    PatientCommonExpressionFromJSON,
    PatientCommonExpressionFromJSONTyped,
    PatientCommonExpressionToJSON,
    PatientCommonExpressionToJSONTyped,
} from './PatientCommonExpression';
import type { UiIdentifier } from './UiIdentifier';
import {
    UiIdentifierFromJSON,
    UiIdentifierFromJSONTyped,
    UiIdentifierToJSON,
    UiIdentifierToJSONTyped,
} from './UiIdentifier';

/**
 * Proxy button data for a BilanGroup's assessment expression
 * @export
 * @interface AssessmentExpr
 */
export interface AssessmentExpr {
    /**
     * 
     * @type {number}
     * @memberof AssessmentExpr
     */
    expressionId: number;
    /**
     * 
     * @type {string}
     * @memberof AssessmentExpr
     */
    buttonText: string;
    /**
     * 
     * @type {boolean}
     * @memberof AssessmentExpr
     */
    buttonMatched: boolean;
    /**
     * 
     * @type {UiIdentifier}
     * @memberof AssessmentExpr
     */
    id: UiIdentifier;
    /**
     * 
     * @type {PatientCommonExpression}
     * @memberof AssessmentExpr
     */
    expression?: PatientCommonExpression;
}

/**
 * Check if a given object implements the AssessmentExpr interface.
 */
export function instanceOfAssessmentExpr(value: object): value is AssessmentExpr {
    if (!('expressionId' in value) || value['expressionId'] === undefined) return false;
    if (!('buttonText' in value) || value['buttonText'] === undefined) return false;
    if (!('buttonMatched' in value) || value['buttonMatched'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function AssessmentExprFromJSON(json: any): AssessmentExpr {
    return AssessmentExprFromJSONTyped(json, false);
}

export function AssessmentExprFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssessmentExpr {
    if (json == null) {
        return json;
    }
    return {
        
        'expressionId': json['expressionId'],
        'buttonText': json['buttonText'],
        'buttonMatched': json['buttonMatched'],
        'id': UiIdentifierFromJSON(json['id']),
        'expression': json['expression'] == null ? undefined : PatientCommonExpressionFromJSON(json['expression']),
    };
}

export function AssessmentExprToJSON(json: any): AssessmentExpr {
    return AssessmentExprToJSONTyped(json, false);
}

export function AssessmentExprToJSONTyped(value?: AssessmentExpr | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'expressionId': value['expressionId'],
        'buttonText': value['buttonText'],
        'buttonMatched': value['buttonMatched'],
        'id': UiIdentifierToJSON(value['id']),
        'expression': PatientCommonExpressionToJSON(value['expression']),
    };
}

